import React, { useState } from 'react';
import AdminResumeManagement from './AdminResumeManagement';
import AdminSettings from './AdminSettings';
import AdminMasterData from './AdminMasterData';

const AdminDashboard = ({ adminInfo, onLogout }) => {
  const [currentView, setCurrentView] = useState('resumes');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminInfo');
    onLogout();
  };

  const renderContent = () => {
    switch (currentView) {
      case 'resumes':
        return <AdminResumeManagement />;
      case 'master-data':
        return <AdminMasterData />;
      case 'settings':
        return <AdminSettings />;
      default:
        return <AdminResumeManagement />;
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Header */}
      <div className="admin-header">
        <div className="header-content">
          <div className="header-left">
            <h1>Admin Portal</h1>
            <p>Welcome back, {adminInfo?.fullName || adminInfo?.username}</p>
          </div>
          <div className="header-right">
            <div className="admin-info">
              <span className="admin-role">System Administrator</span>
              <span className="admin-name">{adminInfo?.username}</span>
            </div>
            <button onClick={handleLogout} className="btn btn-danger">
              🚪 Logout
            </button>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="admin-nav">
        <button
          onClick={() => setCurrentView('resumes')}
          className={`nav-btn ${currentView === 'resumes' ? 'active' : ''}`}
        >
          📄 Resume Management
        </button>
        <button
          onClick={() => setCurrentView('master-data')}
          className={`nav-btn ${currentView === 'master-data' ? 'active' : ''}`}
        >
          🗂️ Master Data
        </button>
        <button
          onClick={() => setCurrentView('settings')}
          className={`nav-btn ${currentView === 'settings' ? 'active' : ''}`}
        >
          ⚙️ Settings
        </button>
      </div>

      {/* Content */}
      <div className="admin-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminDashboard; 